
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OnlineReferralModal from '../../pages/home/components/OnlineReferralModal';

export default function PageNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [referralOpen, setReferralOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const menuItems = [
    { label: 'The Centre', href: '/centre' },
    { label: 'Neuroplasticity', href: '/neuroplasticity' },
    { label: 'Technology', href: '/technology' },
    { label: 'Treatment Programs', href: '/treatment' },
    { label: 'Resources', href: '/resources' },
  ];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="w-full px-6 py-4 flex items-center justify-between">
          {/* Logo & Menu */}
          <div className="flex items-center gap-6">
            <button
              onClick={() => navigate('/')}
              className="text-xl font-bold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
            >
              ARC
            </button>
            
            <div className="relative" ref={menuRef}>
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Menu</span>
                <i
                  className={`ri-arrow-down-s-line transition-transform duration-200 ${
                    menuOpen ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              {menuOpen && (
                <div className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg py-2 min-w-[200px] border border-gray-100">
                  {menuItems.map((item, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        navigate(item.href);
                        setMenuOpen(false);
                      }}
                      className="block w-full text-left px-5 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button
              onClick={() => navigate('/')}
              className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
          </div>

          {/* Online Referral Button */}
          <button
            onClick={() => setReferralOpen(true)}
            className="flex items-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] text-white text-sm font-medium px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap shadow-sm"
          >
            <i className="ri-file-list-3-line"></i>
            <span>Online Referral</span>
          </button>
        </div>
      </nav>

      <OnlineReferralModal isOpen={referralOpen} onClose={() => setReferralOpen(false)} />
    </>
  );
}
